export const tableFields = {

    data() {
        return {
            leaveCommentFields: [
                {key: 'commentDate', sortable: true, label: 'Date'},
                {key: 'name', sortable: true, label: 'Name'},
                {key: 'comment', label: 'Comment'},
                {key: 'standardComment', label: 'Standard Comment'}
            ],
        }
    }
}